import * as React from "react"
import type { SVGProps } from "react"
const SvgConcierge = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M10 22v-2h13v2zm1-3q0-2.03 1.28-3.54 1.27-1.5 3.22-1.86v-.62q0-.44.29-.72.29-.29.71-.29t.71.3q.3.28.29.7v.63q1.92.34 3.21 1.86Q22 16.97 22 19zm2.63-2.02h5.7a4 4 0 0 0-1.22-1.1 3.4 3.4 0 0 0-3.26 0q-.75.41-1.22 1.1M1 13V2h6v1.45l7-1.95L22 4v1q0 1.25-.87 2.13A3 3 0 0 1 19 8h-2v.6q0 .63-.36 1.14t-.94.73L8.95 13zm2-2h2V4H3zm4 0h1.6l5.8-2.12a1 1 0 0 0 .44-.34q.15-.24.16-.54h-1.78l-2.92.95-.6-1.9L12.83 6H19q.23 0 .56-.16.34-.17.34-.39L13.95 3.6 7 5.5z" />
  </svg>
)
export default SvgConcierge
